const LINK_AND_CODE_PREFERENCE = 'linkAndCode';
const ONLY_LINK_PREFERENCE = 'onlyLink';
const WITHOUT_LINK_OR_CODE_PREFERENCE = 'withoutLinkOrCode';

const APPLICATION_FORM_APPROVAL_PREFERENCES = [
  {
    label: 'Affiliate Link & Discount Code',
    value: LINK_AND_CODE_PREFERENCE,
  },
  {
    label: 'Only Affiliate Link',
    value: ONLY_LINK_PREFERENCE,
  },
  {
    label: 'Without Link or Code (Free Product)',
    value: WITHOUT_LINK_OR_CODE_PREFERENCE,
  },
];


export {
  APPLICATION_FORM_APPROVAL_PREFERENCES,
  LINK_AND_CODE_PREFERENCE,
  ONLY_LINK_PREFERENCE,
  WITHOUT_LINK_OR_CODE_PREFERENCE,
};
